<template>
  <div class="login">
    <!-- <header>
      <img src="./../../../assets/images/logo@2x.png" alt="">
    </header> -->
    <div class="body" v-loading="isLoading">
      <i class="iconfont icon-fanhui" @click="goback"></i>
      <div class="form">
        <!-- <h3>星诊所CIS管理系统</h3> -->
        <h3>申请注册</h3>
        <ul>
          <li>
            <i class="iconfont icon-zhanghaodenglu"></i>
            <input type="text" v-model="form.realName" placeholder="姓名" maxlength="10">
          </li>
          <li>
            <i class="iconfont icon-shouji1"></i>
            <input type="text" v-model="form.phone" placeholder="电话" maxlength="15">
          </li>
          <li>
            <i class="iconfont icon-shouye"></i>
            <input type="text" v-model="form.hospitalName" placeholder="诊所名称" maxlength="30">
          </li>
          <li>
            <i class="iconfont icon-dizhi"></i>
            <el-cascader
              :options="optionss"
              v-model="attr"
              placeholder="请选择省/市/区"
              class="input-none-border"
              clearable
              ref='attr'
            ></el-cascader>
          </li>
        </ul>
        <el-button type="primary" @click="submit" style="width: 220px;">立即申请</el-button>
        <div class="tip">感谢您的填写，我们的工作人员会在第一时间与您联系！ </div>
        <div class="tel">客服热线 400-900-1081 转 1 </div>
      </div>
      <footer>
        <img class="logo-ahs" src="./../../../assets/images/logo_ahs_01@2x.png" alt="">
      </footer>
    </div>
  </div>
</template>

<script>
import { cityCode } from '@/utils/cityPicker/cityCode';
import { REG_PHONE } from '@/utils/validate/regExp';

export default {
  data() {
    return {
      form: {
        realName: '',
        phone: '',
        hospitalName: '',
      },
      attr: [],
      optionss: cityCode,
      isLoading: false,
    };
  },
  mounted() {

  },

  methods: {
    submit() {
      if (!REG_PHONE.test(this.form.phone)) {
        this.$message.error('请输入正确的电话号码');
        return;
      }
      this.isLoading = true;
      if (this.attr && this.attr.length > 0) {
        const cityArr = {
          province: this.$refs.attr.currentLabels && this.$refs.attr.currentLabels.length > 2 ? this.$refs.attr.currentLabels[0] : '',
          provinceCode: this.attr[0],
          city: this.$refs.attr.currentLabels && this.$refs.attr.currentLabels.length > 2 ? this.$refs.attr.currentLabels[1] : '',
          cityCode: this.attr[1],
          district: this.$refs.attr.currentLabels && this.$refs.attr.currentLabels.length > 2 ? this.$refs.attr.currentLabels[2] : '',
          districtCode: this.attr[2],
        };
        this.form = Object.assign(this.form, cityArr);
      } else {
        const cityArr = {
          province: '',
          provinceCode: '',
          city: '',
          cityCode: '',
          district: '',
          districtCode: '',
        };
        this.form = Object.assign(this.form, cityArr);
      }
      this.$api.global.registHospitalForTrial({ ...this.form }).then((res) => {
        this.$message({
          message: '提交成功！我们将会在第一时间与您联系。',
          type: 'success',
        });
        this.isLoading = false;
        setTimeout(() => {
          this.goback();
        }, 1000);
      }).catch(() => {
        this.isLoading = false;
      });
    },
    goback() {
      this.$store.commit('loginOut');
      this.$router.push({ name: 'login' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
